export default "<iframe #dynamiciframe [ngStyle]=\"style\" [scrolling]=\"scrolling\" ><p>Your browser does not support iframes.</p></iframe>\r\n"